export function objectToQueryString (obj: Record<string, string | number>) {
  return Object.entries(obj)
    .map(([key, value]) => `${ encodeURIComponent(key) }=${ encodeURIComponent(value) }`)
    .join('&');
}
